import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Details } from '../components/details/details';
import { Search } from '../components/form-search/form-search';
import { Delete } from '../components/form-delete/form-delete';
import { Create } from '../components/form-manager/form-manager';
import { Reminder } from '../components/form-reminder/form-reminder';
import { SearchResult } from '../components/search-result/search-result';
import { Communication } from '../components/communication/communication';

import Header from '../../../components/header/header';

import { searchAmendments, setDefaultPageRules } from '../actions/form-search';
import { getUsersOptions, getDepartments, getStageAmendments } from '../../../actions/select-options';

import { formattedDateTime } from '../../../utils';

import paginationDefault from '../../../constants/pagination';

class Amendment extends Component {
  componentDidMount() {
    const {
      getUsersOptions,
      getDepartments,
      getStageAmendments,

      searchAmendments,
      setDefaultPageRules,

      reference,
      categoryId,
      statusId,
      startDateExpense,
      endDateExpense,
      recipient,
      isRefund,
    } = this.props;

    getUsersOptions();
    getDepartments();
    getStageAmendments();

    setDefaultPageRules();
    searchAmendments({
      reference,
      categoryId,
      statusId,
      startDateExpense: formattedDateTime(startDateExpense),
      endDateExpense: formattedDateTime(endDateExpense),
      recipient,
      isRefund,
      page: paginationDefault.page,
      limit: paginationDefault.limit,
    });
  }

  render() {
    const {
      userLogged,
    } = this.props;

    return (
      <>
        <Header userLogged={userLogged} />
        <SearchResult />

        <Search />
        <Delete />
        <Create />
        <Reminder />
        <Details />
        <Communication />
      </>
    )
  }
}

const mapStateToProps = ({ expenseReducer: { formSearch }, authReducer: { authenticated } }) => ({
  userLogged: authenticated,

  reference: formSearch.reference,
  categoryId: formSearch.categoryId,
  statusId: formSearch.statusId,
  startDateExpense: formSearch.startDateExpense,
  endDateExpense: formSearch.endDateExpense,
  recipient: formSearch.recipient,
  isRefund: formSearch.isRefund,
});

const mapDispatchToProps = dispath => {
  return bindActionCreators({
    getUsersOptions,
    getDepartments,
    getStageAmendments,

    searchAmendments,
    setDefaultPageRules,
  }, dispath)
};

export default connect(mapStateToProps, mapDispatchToProps)(Amendment);
